var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"append-to-body":true,"title":'Give feedback',"visible":_vm.isVisible,"width":"60%","data-test-id":"myGamesFeedbackModal"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('Feedback',{attrs:{"game":_vm.game,"display-send-form":""},on:{"close-pop-in":function($event){return _vm.$emit('close')}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }